module.exports = __webpack_public_path__ + "static/media/cash-for-used-car-woodridge.cff5860c.png";